import React from "react";
import Box from "@material-ui/core/Box";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

import { compose, defaultProps, withHooks } from "enhancers";
import { AppColor } from "theme/app-color";
import Typography from "./Typography";
import { get, isEmpty } from "lodash";
import { InputLabel } from "@material-ui/core";
import T from "./T";

const Editor = ({
  layoutProps,
  editorProps,
  isError,
  error,
  label,
  required,
  name,
  labelVariant,
}: any) => (
  <Box {...layoutProps}>
    {label && (
      <InputLabel shrink htmlFor={name}>
        <Typography
          variant={labelVariant}
          color={AppColor["Text/Primary Text"]}
        >
          {label}
          <span style={{ color: AppColor["SecondaryText/Danger"] }}>
            {required && " *"}
          </span>
        </Typography>
      </InputLabel>
    )}
    <Box mt={1}>
      <ReactQuill ref={editorProps.outerRef} {...editorProps} />
    </Box>
    {isError && (
      <Box mt={1}>
        <T variant="Helper/12" color={AppColor["SecondaryText/Danger"]}>
          {error}
        </T>
      </Box>
    )}
  </Box>
);

const enhancer = compose(
  defaultProps({
    theme: "snow",
    modules: {
      toolbar: [
        // [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
        ["clean"],
      ],
      clipboard: true,
      history: true,
    },
  }),
  withHooks((props: any, hooks: any) => {
    const {
      form,
      field,
      theme,
      placeholder,
      outerRef,
      modules,
      label,
      required,
      labelVariant = "Header/24",
      ...rest
    } = props;
    const { useMemo, useCallback } = hooks;

    const { setFieldValue, setFieldTouched } = form;
    const { name, value } = field;
    const layoutProps = rest;

    const touched = get(props.form.touched, props.field.name, false);

    const onChange = useCallback(
      (value: any) => {
        // console.log(value);
        const isEmptyContent = isEmpty(value) || value === "<p><br></p>";
        if (isEmptyContent && props.required) {
          form.setFieldError(name, "This field is required");
          setFieldValue(name, "");
        } else {
          setFieldValue(name, isEmptyContent ? "" : value);
        }

        if (!touched) setFieldTouched(name, true);
      },
      [props.required, touched, setFieldTouched, name, form, setFieldValue]
    );

    const editorProps = useMemo(() => {
      return {
        theme,
        placeholder,
        onChange,
        value: value ?? "",
        outerRef,
        modules,
      };
    }, [theme, placeholder, onChange, value, outerRef, modules]);

    const errors = useMemo(() => {
      const error = get(props.form.errors, props.field.name);
      return { isError: touched && !!error, error };
    }, [props.form.errors, props.field.name, touched]);

    return {
      layoutProps,
      editorProps,
      ...errors,
      label,
      required,
      name,
      labelVariant,
    };
  })
);

export default enhancer(Editor);
